import { useQuery } from "react-query";
import findCompanies from "v2/domain/common/useCases/findCompanies";

export default function useCompanies() {
  return useQuery(["companies"], findCompanies, {
    initialData: undefined,
  });
}
